import pageLoader from "./../../public/giff/pageLoader.gif";

const CustomSpinner = () => {
  return (
    <div
      style={{
        width: "100%",
        // height: "100%",
        marginTop: "50px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img src={pageLoader} alt="Loading..." width={80} />
    </div>
  );
};

export default CustomSpinner;
